export function buildTrouserBlocks(generated = {}) {
  return [
    { key: 'front', label: 'Front', path: generated.frontPath || '', enabled: Boolean(generated.frontPath) },
    { key: 'back', label: 'Back', path: generated.backPath || '', enabled: Boolean(generated.backPath) },
  ];
}

export function getTrouserBlockByKey(generated = {}, key) {
  return buildTrouserBlocks(generated).find((block) => block.key === key) || null;
}
